import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useTheme} from '@mui/material/styles';

export function CoverageExtensionsList({children}) {
  const theme = useTheme();
  return (
    <div>
      <div style={{textAlign: 'center', marginBottom: 8}}>
        <div style={{fontWeight: theme.typography.fontWeightBlack, fontSize: theme.typography.pxToRem(20), color: theme.palette.secondary.main}}>
          <FormattedMessage id='coverage.extensionsTitle'/>
        </div>
        <div style={{fontSize: theme.typography.pxToRem(13), color: theme.palette.text.secondary, marginTop: 3}}>
          <FormattedMessage id='coverage.extensionsSubtitle'/>
        </div>
      </div>
      {children}
    </div>
  );
}
